<template>
  <div>
    <ToolbarAuth />
    <div class="mt-15 ml-15 mr-15">
      <v-card elevation="15" class="mb-15">
        <v-card-title class="primary--text">Noodplan BV </v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead></thead>
            <tbody>
              <tr>
                <td class="accent--text">Personalia</td>
                <td></td>
              </tr>
              <tr>
                <td>id</td>
                <td>{{ bv_planSingle.id }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.gender") }}</td>
                <td v-if="bv_planSingle.gender_client === '1'">Heer</td>
                <td v-if="bv_planSingle.gender_client === '2'">Mevrouw</td>
              </tr>
              <tr>
                <td>Voornaam</td>
                <td>{{ bv_planSingle.first_name_client }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.last_name") }}</td>
                <td>{{ bv_planSingle.last_name_client }}</td>
              </tr>
              <tr>
                <td>Adres</td>
                <td>{{ bv_planSingle.address_client }}</td>
              </tr>
              <tr>
                <td>Postcode</td>
                <td>{{ bv_planSingle.zip_client }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.place") }}</td>
                <td>{{ bv_planSingle.place_client }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ bv_planSingle.email_client }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.telephone") }}</td>
                <td>{{ bv_planSingle.phone_number_client }}</td>
              </tr>
              <tr>
                <td class="accent--text">Bedrijf</td>
                <td></td>
              </tr>
              <tr>
                <td>Bedrijfsnaam</td>
                <td>{{ bv_planSingle.name_company }}</td>
              </tr>
              <tr>
                <td>Adres</td>
                <td>{{ bv_planSingle.address_company }}</td>
              </tr>
              <tr>
                <td>Postcode</td>
                <td>{{ bv_planSingle.zip_company }}</td>
              </tr>
              <tr>
                <td>Vestigingsplaats</td>
                <td>{{ bv_planSingle.place_company }}</td>
              </tr>
              <tr>
                <td class="accent--text">Structuur</td>
                <td></td>
              </tr>
              <tr>
                <td>Wordt belang aangehouden via personal holding</td>
                <td v-if="bv_planSingle.question_a === 'ke1'">Ja</td>
                <td v-if="bv_planSingle.question_a === 'ke2'">Nee</td>
              </tr>
              <tr v-if="bv_planSingle.question_a === 'ke1'">
                <td>Wat is de positie van de personal holding is deze BV</td>
                <td v-if="bv_planSingle.question_b === 'ke1'">Enig aandeel- of certificaathouder</td>
                <td v-if="bv_planSingle.question_b === 'ke2'">Meerderheidsaandeel- of certificaathouder (50% of meer)</td>
                <td v-if="bv_planSingle.question_b === 'ke3'">Meerderheidsaandeel- of certificaathouder (minder dan 50%)</td>
              </tr>
              <tr v-if="bv_planSingle.question_a === 'ke2'">
                <td>Wordt belang aangehouden via tussen-holding</td>
                <td v-if="bv_planSingle.question_c === 'ke1'">Ja</td>
                <td v-if="bv_planSingle.question_c === 'ke2'">Nee</td>
              </tr>
              <tr v-if="bv_planSingle.question_c === 'ke1' && bv_planSingle.question_a=== 'ke2'">
                <td>Wat is de positie van de tussen holding is deze BV</td>
                <td v-if="bv_planSingle.question_d === 'ke1'">Enig aandeel- of certificaathouder</td>
                <td v-if="bv_planSingle.question_d === 'ke2'">Meerderheidsaandeel- of certificaathouder (50% of meer)</td>
                <td v-if="bv_planSingle.question_d === 'ke3'">Meerderheidsaandeel- of certificaathouder (minder dan 50%)</td>
              </tr>
              <tr>
                <td class="accent--text">App</td>
                <td></td>
              </tr>
              <tr>
                <td>Kan de klant gebruik maken van de App</td>
                <td v-if="bv_planSingle.useApp === 'ke1'">Ja</td>
                <td v-if="bv_planSingle.useApp === 'ke2'">Nee</td>
              </tr>

              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Stijl e-mail uitnodiging </td>
                <td v-if="bv_planSingle.style === 'ke1'">Formeel</td>
                <td v-if="bv_planSingle.style === 'ke2'">Informeel</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Persoonlijke tekst e-mail uitnodiging</td>
                <td v-if="bv_planSingle.personalNote === 'ke1'">Ja</td>
                <td v-if="bv_planSingle.personalNote === 'ke2'">Nee</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Toegevoegde tekst</td>
                <td>{{ bv_planSingle.personalNoteText }}</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Uitnodiging verzonden (e-mail)</td>
                <td v-if="bv_planSingle.invitation_send"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.invitation_send"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Datum uitnodiging verzonden (e-mail)</td>
                <td v-if="bv_planSingle.invitation_send">{{ bv_planSingle.date_invitation_send | myDate}}</td>
                <td v-if="!bv_planSingle.invitation_send">nog niet verzonden</td>
              </tr>
              <tr>
                <td class="accent--text">Voortgang</td>
                <td></td>
              </tr>
              <tr>
                <td>Noodopvolging</td>
                <td v-if="bv_planSingle.finishModA"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModA"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Voortzetting door familie</td>
                <td v-if="bv_planSingle.finishModB"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModB"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Voortzetting door medewerkers</td>
                <td v-if="bv_planSingle.finishModC"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModC"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Verkoop aan een externe partij</td>
                <td v-if="!bv_planSingle.useModD">n.v.t.</td>
                <td v-if="bv_planSingle.finishModD && bv_planSingle.useModD"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModD && bv_planSingle.useModD"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Staking van activiteiten</td>
                <td v-if="bv_planSingle.finishModE"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModE"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td v-if="bv_planSingle.useModF">Structuur</td>
                <td v-if="!bv_planSingle.useModF" class="info--text">Structuur LET OP ZELF AANVULLEN IN RAPPORT</td>
                <td v-if="bv_planSingle.finishModF"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModF"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Mede-eigenaren</td>
                <td v-if="!bv_planSingle.useModG">Wordt niet gebruikt</td>
                <td v-if="bv_planSingle.finishModG && bv_planSingle.useModG"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModG && bv_planSingle.useModG"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Bedrijfsstrategie</td>
                <td v-if="bv_planSingle.finishModH"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModH"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Finance & IT</td>
                <td v-if="bv_planSingle.finishModI"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModI"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Rol van de ondernemer</td>
                <td v-if="bv_planSingle.finishModJ"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModJ"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Management en Medewerkers</td>
                <td v-if="bv_planSingle.finishModK"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModK"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Leveranciers</td>
                <td v-if="bv_planSingle.finishModL"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModL"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Klanten</td>
                <td v-if="bv_planSingle.finishModM"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModM"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td>Adviseurs</td>
                <td v-if="bv_planSingle.finishModN"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.finishModN"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr>
                <td class="accent--text">Laatste update (door klant of kantoor)</td>
                <td></td>
              </tr>
              <tr>
                <td>Noodopvolging</td>
                <td v-if="bv_planSingle.finishModA">{{ bv_planSingle.date_mod_a_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModA">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Voortzetting door de familie</td>
                <td v-if="bv_planSingle.finishModB">{{ bv_planSingle.date_mod_b_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModB">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Voortzetting door medewerkers</td>
                <td v-if="bv_planSingle.finishModC">{{ bv_planSingle.date_mod_c_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModC">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Verkoop aan een externe partij</td>
                <td v-if="bv_planSingle.finishModD">{{ bv_planSingle.date_mod_d_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModD">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Staking van activiteiten</td>
                <td v-if="bv_planSingle.finishModE">{{ bv_planSingle.date_mod_e_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModE">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Structuur</td>
                <td v-if="bv_planSingle.finishModF">{{ bv_planSingle.date_mod_f_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModF">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Mede-eigenaren</td>
                <td v-if="!bv_planSingle.useModG">Wordt niet gebruikt</td>
                <td v-if="bv_planSingle.finishModG && bv_planSingle.useModG">{{ bv_planSingle.date_mod_g_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModG && bv_planSingle.useModG">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Bedrijfsstrategie</td>
                <td v-if="bv_planSingle.finishModH">{{ bv_planSingle.date_mod_h_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModH">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Finance & IT</td>
                <td v-if="bv_planSingle.finishModI">{{ bv_planSingle.date_mod_i_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModI">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Rol van de ondernemer</td>
                <td v-if="bv_planSingle.finishModJ">{{ bv_planSingle.date_mod_j_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModJ">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Management en Medewerkers</td>
                <td v-if="bv_planSingle.finishModK">{{ bv_planSingle.date_mod_k_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModK">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Leveranciers</td>
                <td v-if="bv_planSingle.finishModL">{{ bv_planSingle.date_mod_l_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModL">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Klanten</td>
                <td v-if="bv_planSingle.finishModM">{{ bv_planSingle.date_mod_m_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModM">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td>Adviseurs</td>
                <td v-if="bv_planSingle.finishModN">{{ bv_planSingle.date_mod_n_updated | myDate}}</td>
                <td v-if="!bv_planSingle.finishModN">Nog niet ingevuld</td>
              </tr>
              <tr>
                <td class="accent--text">Actualisatie (een of meerdere modules langer dan 1 jaar geleden gewijzigd)</td>
                <td></td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Jaarlijkse reminder actualisatie</td>
                <td v-if="bv_planSingle.yearly_reminder === 'ke1'">Ja</td>
                <td v-if="bv_planSingle.yearly_reminder === 'ke2'">Nee</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke2'">
                <td>Jaarlijkse reminder actualisatie</td>
                <td>N.V.T. (geen gebruik app)</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Jaarlijkse actualisatie mail</td>
                <td v-if="bv_planSingle.yearly_reminderA_send">{{ bv_planSingle.date_last_yearly_reminderA_send | myDate}}</td>
                <td v-if="!bv_planSingle.yearly_reminderA_send">nog niet verzonden</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Jaarlijkse actualisatie mail (herinnering)</td>
                <td v-if="bv_planSingle.yearly_reminderB_send">{{ bv_planSingle.date_last_yearly_reminderB_send | myDate}}</td>
                <td v-if="!bv_planSingle.yearly_reminderB_send">nog niet verzonden</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Jaarlijkse actualisatie mail (bericht relatie-manager)</td>
                <td v-if="bv_planSingle.yearly_reminderC_send">{{ bv_planSingle.date_last_yearly_reminderC_send | myDate}}</td>
                <td v-if="!bv_planSingle.yearly_reminderC_send">nog niet verzonden</td>
              </tr>

            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeView()" large class="ma-5" color="accent"> {{ $t("crud.close") }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-spacer></v-spacer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
export default {
  name: "userview",
  components: { ToolbarAuth },
  data() {
    return {
      email: "",
      search: "",
      headers: [
        {
          text: this.$t("users.users"),
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "EMAIL", sortable: true, value: "email" },
        { text: this.$t("crud.actions"), value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    closeView() {
      this.$router.push({ name: "bvIndex" });
    },
  },
  computed: {
    ...mapGetters("bvSingle", ["loading", "error", "bv_planSingle"]),
  },
  created() {
    let ClientId = this.$route.params.id;
    this.$store.dispatch("bvSingle/getBVplan", ClientId);
  },
};
</script>

<style scoped></style>
